// frontend/src/components/common/GlobalModals.jsx (FIXED VERSION)
import React, { useEffect } from 'react';
import { useModal } from '../../contexts/ModalContext';
import { useAuth } from '../../contexts/AuthContext';

// Import modal components
import CreatePostOverlay from '../create/CreatePostOverlay';
import CreateNewContentPage from '../../pages/CreateNewContentPage';
// Import other modal components as needed

// Modal type constants
export const MODAL_TYPES = {
  CREATE_POST: 'createPost',
  CREATE_NEW_CONTENT_SELECTION: 'createNewContent',
  // Add other modal types as needed
};

const GlobalModals = ({ commonModalProps = {} }) => {
  const { modalType, modalProps = {}, closeModal } = useModal();
  const { currentUser } = useAuth();

  // Debug logging (you can remove these in production)
  useEffect(() => {
    console.log('[GlobalModals] Modal type changed to:', modalType);
  }, [modalType]);

  // REMOVED THE MAPPING LOGIC THAT WAS CAUSING THE ISSUE
  // Let each modal type render its own component
  
  // Render the appropriate modal based on modalType
  switch (modalType) {
    case MODAL_TYPES.CREATE_NEW_CONTENT_SELECTION:
      // Show the CreateNewContentPage as a modal
      return <CreateNewContentPage />;
    
    case MODAL_TYPES.CREATE_POST:
      // This shows when "Create a New Post" is clicked from the menu
      return (
        <CreatePostOverlay
          isOpen={true}
          onClose={closeModal}
          currentUser={currentUser}
          {...modalProps}
        />
      );
    
    // Add other modal cases here as needed
    // case MODAL_TYPES.SOME_OTHER_MODAL:
    //   return <SomeOtherModal ... />
    
    default:
      return null;
  }
};

export default GlobalModals;